import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'sp-add-eunify-credential',
  templateUrl: './add-eunify-credential.component.html',
  styleUrls: ['./add-eunify-credential.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AddEUnifyCredentialComponent {
  @Input() formGroup: FormGroup;
}
